import { Injectable } from '@angular/core';
import { SyncedStorage } from '../app-commons/synced-storage/synced-storage';
import { Observable, ReplaySubject } from 'rxjs';
import { Season } from './season';
import { RacePlan } from './race-plan/race-plan';
import { RemoteCommand } from './settings/remote-command';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SeasonService {

  readonly syncedStorage$ = new ReplaySubject<SyncedStorage<Season | RacePlan | RemoteCommand>>(1);

  public readonly activeSeason$: Observable<SyncedStorage.Doc<Season>> = this.syncedStorage$.pipe(
    switchMap((syncedStorage) => syncedStorage.watchType$<Season>('Season')),
    map((seasons) => seasons[0]),
    filter((season) => !!season),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  constructor() {
  }
}
